import React from 'react';

import { RequestExceptionWithResponse } from '@eika-infrastruktur/request';
import { Button } from '@eika/button';

import { ErrorCardWrapper } from '../../components/shared/ErrorCardWrapper';
import useTranslation from '../../hooks/useTranslation';

type FuturePaymentsListErrorProps = {
    error: RequestExceptionWithResponse | null;
    refresh: () => void;
};

const FuturePaymentsListError: React.FC<FuturePaymentsListErrorProps> = ({ error, refresh }) => {
    const translated = useTranslation();

    if (error) {
        return (
            <>
                <ErrorCardWrapper
                    title={translated.errors.somethingWentWrong}
                    exception={error}
                    defaultError={translated.futurePaymentsList.couldNotGetFuturePayments}
                    className="future-payments-list-page__error-card"
                >
                    <Button onClick={refresh}>{translated.tryAgain}</Button>
                </ErrorCardWrapper>
            </>
        );
    }

    return <></>;
};

export default FuturePaymentsListError;
